import { FormGroup } from '@angular/forms';

// * some day this might be a directive but for now it is not necessary
export function isFieldInvalid(form: FormGroup, fieldName: string): boolean {
  const field = form.get(fieldName);
  return !!(field?.invalid && (field?.touched || field?.dirty));
}
